import { WalletIcons, WalletProps } from "rujira.ui";

export const WALLETS: WalletProps[] = [
  {
    key: "brave",
    label: "Brave",
    provider: "Brave",
    icon: <WalletIcons.Brave />,
    url: "https://brave.com/wallet/",
  },
  {
    key: "coinbase",
    label: "Coinbase",
    provider: "Coinbase",
    icon: <WalletIcons.Coinbase />,
    url: "https://www.coinbase.com/en-gb/wallet",
  },
  {
    key: "daodao",
    label: "DaoDao",
    provider: "DaoDao",
    icon: <WalletIcons.Daodao className="color-white" />,
  },
  {
    key: "keplr",
    label: "Keplr",
    provider: "Keplr",
    icon: <WalletIcons.Keplr />,
    url: "https://www.keplr.app/",
  },
  {
    key: "metamask",
    label: "Metamask",
    provider: "Metamask",
    icon: <WalletIcons.MetaMask />,
    url: "https://metamask.io/",
  },
  {
    key: "rabby",
    label: "Rabby",
    provider: "Rabby",
    icon: <WalletIcons.Rabby />,
    url: "https://rabby.io/",
  },
  {
    key: "okx",
    label: "OKX",
    provider: "Okx",
    icon: <WalletIcons.OKX className="color-white" />,
    url: "https://web3.okx.com",
  },
  {
    key: "trust-extension",
    label: "Trust Extension",
    provider: "Trust",
    icon: <WalletIcons.Trust />,
    url: "https://trustwallet.com/browser-extension",
  },
  {
    key: "vultisig",
    label: "Vultisig",
    provider: "Vulticonnect",
    icon: <WalletIcons.Vultisig />,
    url: "https://vultisig.com",
  },
];
